import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Amplify } from 'aws-amplify';
import router from './config/router';
import { store, persistor } from './store';
import amplifyConfig from './config/amplify';
import './styles/index.css';

// Configure AWS Amplify with authentication support
Amplify.configure(amplifyConfig);

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
